export default __webpack_public_path__ + "static/media/bootstrap-svg.6b8a49b2.png";